import React, { PropsWithChildren } from "react";

import { Button } from "components/ui/button";

interface Props {
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    isActive: boolean;
    pageClassName?: string;
    pageLinkClassName?: string;
    activeClassName?: string;
}

const PagerItem: React.FC<PropsWithChildren<Props>> = ({
    onClick,
    isActive,
    pageClassName = "pagination-item",
    pageLinkClassName: _pageLinkClassName = "pagination-link",
    activeClassName = "pagination-item pagination-item--active",
    children,
}) => {
    let className = pageClassName;
    if (isActive) {
        className = activeClassName;
    }

    return (
        <li className={className}>
            <Button
                type="button"
                onClick={onClick}
                variant={isActive ? "default" : "outline"}
                size="icon"
                className="h-9 w-9 rounded-xl"
            >
                {children}
            </Button>
        </li>
    );
};

export default PagerItem;
